/**
 * useOfficeManifest — dynamically swap the browser's PWA manifest so that
 * when a browser loads /admin (or /kitchen, /staff), the install prompt
 * offers "Mamamina Office" with the dark theme + dedicated icon, instead
 * of the customer-facing "Mamamina's Soulfeed" manifest.
 *
 * The swap is scoped to the mount lifecycle — going back to the customer
 * site restores the customer manifest cleanly.
 */
import { useEffect } from "react";

const CUSTOMER_MANIFEST = "/manifest.json";
const OFFICE_MANIFEST = "/office-manifest.json";
const OFFICE_THEME = "#B7853D";
const CUSTOMER_THEME = "#14100c";
const OFFICE_APPLE_ICON = "/media/office-icon-300.png";

export function useOfficeManifest() {
  useEffect(() => {
    const linkEl = document.querySelector('link[rel="manifest"]');
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const appleIconEl = document.querySelector('link[rel="apple-touch-icon"]');
    const originalHref = linkEl?.getAttribute("href");
    const originalTheme = themeMeta?.getAttribute("content");
    const originalAppleIcon = appleIconEl?.getAttribute("href");

    if (linkEl) linkEl.setAttribute("href", OFFICE_MANIFEST);
    if (themeMeta) themeMeta.setAttribute("content", OFFICE_THEME);
    if (appleIconEl) appleIconEl.setAttribute("href", OFFICE_APPLE_ICON);

    // Also update the document title so the Add-to-Home-Screen name reads
    // right on iOS Safari (which doesn't fully honour the manifest name).
    const originalTitle = document.title;
    document.title = "Mamamina Office · Backroom";

    return () => {
      if (linkEl) linkEl.setAttribute("href", originalHref || CUSTOMER_MANIFEST);
      if (themeMeta) themeMeta.setAttribute("content", originalTheme || CUSTOMER_THEME);
      if (appleIconEl && originalAppleIcon) appleIconEl.setAttribute("href", originalAppleIcon);
      document.title = originalTitle;
    };
  }, []);
}
